import { render, staticRenderFns } from "./Skewness.vue?vue&type=template&id=76bec97b&scoped=true&"
import script from "./Skewness.vue?vue&type=script&lang=js&"
export * from "./Skewness.vue?vue&type=script&lang=js&"
import style0 from "./Skewness.vue?vue&type=style&index=0&id=76bec97b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bec97b",
  null
  
)

export default component.exports